import React, { useRef, useState } from "react";
import Select, { Option } from "rc-select";
import "./Filter.css";

export default function Filter(props) {
  const searchRef = useRef();

  const [searchholding, setSearchHolding] = useState("");

  return (
    <div className="filter px-4">
      <div className="filterleft">
        <button className={"NavLinkBtn hover marginright unselectlink"}>
          Records : {props.records}
        </button>
      </div>
      <div className="filterright">
        <div className="margin-right">
          <input
            ref={searchRef}
            type="text"
            name="search"
            id="search"
            autoComplete="new-password"
            placeholder="Search Symbol"
            class="input bg-[var(--background)] border-2 h-8 border-[var(--hover)] text-[var(--text)] text-sm rounded-full focus:ring-[var(--primary)] focus:border-[var(--primary)] block w-full p-2.5"
            value={searchholding}
            onChange={(e) => {
              setSearchHolding(e.target.value);
              props.search(e.target.value);
            }}
          />
        </div>
      </div>
    </div>
  );
}
